import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useNavigate, Link } from "react-router-dom";
import BarAdmin from "./admin/BarAdmin";

export default function EspaceBarman() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (!user) return <Navigate to="/connexion" replace />;
  if (!user.is_admin && !user.is_barman) {
    return (
      <div className="container">
        <div className="error">Accès réservé aux barmen.</div>
      </div>
    );
  }

  const doLogout = async () => { await logout(); nav("/"); };

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "space-between",
                    alignItems: "baseline", flexWrap: "wrap", gap: "1rem" }}>
        <h1>Espace barman</h1>
        <div className="muted">
          {user.prenom} {user.nom}
          {user.is_admin && <span style={{ marginLeft: 8 }}>🛡 Admin</span>}
          {user.is_barman && <span style={{ marginLeft: 8 }}>🍻 Barman</span>}
          <button className="secondary small" style={{ marginLeft: "1rem" }} onClick={doLogout}>
            Déconnexion
          </button>
        </div>
      </div>
      <p className="muted" style={{ marginBottom: "1rem" }}>
        Pour vous inscrire à un créneau, consultez la{" "}
        <Link to="/bar-associatif">page publique du bar</Link>.
      </p>
      <BarAdmin />
    </div>
  );
}
